import Swiper from "swiper";
import {Tracking} from "../../tracking/tracking";
import {paramsZoom} from "./productSwiper";

declare const c: {
  revealPopup: (selector: string) => void
};

export class BwareSwiper {
  constructor(anchor: HTMLAnchorElement) {
    anchor.addEventListener("click", (evt) => {
      evt.preventDefault();
      const itemId = (evt.currentTarget as HTMLAnchorElement).dataset.itemid;
      c.revealPopup(`#DesignSalePopup${itemId}`);
      Tracking.sendEvent("OutletSwiper.Revealed");
      const container = document.querySelector(`.swiper-container[data-itemid="${itemId}"]`) as HTMLElement;
      paramsZoom.on.slideChange = slideChange;
      const swiper = new Swiper(container, paramsZoom);
      swiper.loaded = true;
    });
  }
}

function slideChange() {
  if (this.loaded) {
    Tracking.sendEvent("OutletSwiper.Swiped");
  }
}
